import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchProjectTree, setFetchStatus } from "slices/project_work";

export const copyEstimateDocument = createAsyncThunk("estimateViewer/copyEstimateDocument", async (arg, { extra, getState, dispatch }) => {
	const state = getState();
	const projectId = state.projectWork.main.id;

	const currentEstmDocId = state.ribbon.currentEstmDocId;
	const currentPage = state.ribbon.currentPage;
	const currentEstmDocUrlPart = state.ribbon.currentEstmDocUrlPart;

	let prom;

	if (currentPage === "LocalEstimateViewer" || currentEstmDocUrlPart === "lsr") {
		prom = extra.apiLocalEstimate.copyDoc({ estmId: currentEstmDocId });
	} else if (currentPage === "VorViewer" || currentEstmDocUrlPart === "vor") {
		prom = extra.apiVor.copyDoc({ estmId: currentEstmDocId });
	}
	if (!prom) return;

	dispatch(setFetchStatus("loading"));

	prom.then((response) => {
		dispatch(fetchProjectTree(projectId));
		dispatch(setFetchStatus("success"));
	}).catch((error) => {
		console.error(error);
		dispatch(setFetchStatus("failed"));
	});
});
